/** favicar.ru and its staging favicar.devru are the RU contour: its own API, country and links. */
export const isRuDomain = (): boolean => /\.(dev)?ru$/.test(window.location.hostname)
